import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractFascia} from "../../abstract-fascia";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-filter-fascia",
    styleUrls: ["./filter-fascia.component.scss"],
    templateUrl: "./filter-fascia.component.html",
    standalone: false
})
export class FUIFilterFasciaComponent extends FUIAbstractFascia {

}
